import { uuidv4 } from '@firebase/util';
import { Request, Venue } from '@prisma/client';
import axios from 'axios';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { firebase } from './firebase';

export async function getRequests() {
  try {
    const request = await axios.get<(Request & { venue: Venue })[]>(
      '/api/rfp/inbox'
    );

    return request.data;
  } catch {
    return [];
  }
}

export async function createRequest(
  venue_id: string,
  data: Partial<Request>,
  attachments: File[]
) {
  const storage = getStorage(firebase.getApp());
  const uuid = uuidv4();

  const files: {
    name: string;
    type: string;
    size: number;
    url: string;
  }[] = [];

  for (const attachment of attachments) {
    console.log(`${uuid}/${attachment.name}`);
    const storageRef = ref(storage, `request/${uuid}/${attachment.name}`);
    console.log({ storageRef, attachment });
    const upload = await uploadBytes(storageRef, attachment);

    const [name, type] = attachment.name.split('.');
    files.push({
      name,
      type,
      size: attachment.size,
      url: upload.ref.fullPath,
    });
  }

  const response = await axios.post(`/api/rfp/venue/${venue_id}`, {
    ...data,
    attachments: files,
  });

  return response;
}
